export const formatRate = (rate: ApplicationRate | null | undefined) => {
  if (!rate) {
    return null;
  }

  const rateAmt = rate?.rate_amt;
  if (!Number.isFinite(rateAmt)) {
    return null;
  }

  const rateType = rate?.rate_type;
  if (rateType === 'hourly') {
    return `$${rateAmt}/hr`;
  }

  const guarantee = rate?.guarantee;
  if (!Number.isFinite(guarantee)) {
    return null;
  }

  return `$${rateAmt}/${guarantee}`;
};
